import * as FileSaver from 'file-saver'
import XLSX from 'sheetjs-style'



import {
    trataValorTexto,
} from '../../views/clientes/cliente-form/ClienteServiceImportacao'



const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
const fileExtension = '.xlsx'

export const exportToExcel = async (listExcel, nomeArquivoExcel) => {

    const ws = XLSX.utils.json_to_sheet(listExcel)
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] }
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const data = new Blob([excelBuffer], { type: fileType })
    FileSaver.saveAs(data, nomeArquivoExcel + fileExtension)
}

const ajustaCampoListExcel = (campo) => {

    if (('' + campo).indexOf('R$') !== -1) {

        campo = trataValorTexto(campo)
    }

    return campo
}

export const formataListExcel = (listExcel, campos) => {

    const listExcelTratada = []

    listExcel?.forEach( (linhaListExcel, indListExcel) => {

        listExcelTratada.push({})

        campos?.forEach( (linhaCampos, indCampos) => {

            listExcelTratada[indListExcel] = {
                ...listExcelTratada[indListExcel],
                [linhaCampos]:
                    linhaListExcel[linhaCampos] && linhaListExcel[linhaCampos].props
                        ?
                            Array.isArray(linhaListExcel[linhaCampos].props.children)
                                ?
                                    ajustaCampoListExcel(linhaListExcel[linhaCampos].props.children[0])
                                :
                                    ajustaCampoListExcel(linhaListExcel[linhaCampos].props.children)
                        :
                            linhaListExcel[linhaCampos]
                                ?
                                    linhaListExcel[linhaCampos]
                                :
                                    ''
            }
        })
    })

    return listExcelTratada
}